import { create } from "zustand";

type MenuType = "C4" | "KSS" | "NOTHING"; // NOTHING is 아무것도 선택 안된 상태

interface SelectedMenuState {
  selectedMenu: MenuType;
  setSelectedMenu: (menu: MenuType) => void;
  clearSelectedMenu: () => void;
}

const useSelectedMenuStore = create<SelectedMenuState>((set) => ({
  selectedMenu: "NOTHING",
  setSelectedMenu: (menu) => set({ selectedMenu: menu }),
  clearSelectedMenu: () => set({ selectedMenu: "NOTHING" }),
}));

export default useSelectedMenuStore;
